import Vue from 'vue'
import axios from "axios";
import router from "../router";

const axiosInstance = axios.create({
    timeout: 30000,
    baseURL: '/api/',
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
    }
});

// 添加响应拦截器
axiosInstance.interceptors.response.use(function (response) {
    if (response.data.code == 4010) {
        router.push('/login');
        return null;
    }
    return response.data;
}, function (error) {
    Vue.prototype.$message.error(error.response.data.message);
    return Promise.reject(error);
});

const get = function (uri, params) {
    const loading = Vue.prototype.$loading({
        lock: true,
        background: 'rgba(0, 0, 0, 0)',
    });
    return axiosInstance.get(uri, {
        params: params,
    }).then(res => {
        loading.close();
        if (res.code != 0) {
            Vue.prototype.$message.error(res.msg);
        }
        return res;
    }).catch(e => {
        loading.close();
        return {code: e.response.status || 500, msg: e.response.data.message};
    });
}

const post = function (uri, data) {
    const loading = Vue.prototype.$loading({
        lock: true,
        background: 'rgba(0, 0, 0, 0)',
    });
    return axiosInstance.post(uri, data).then(res => {
        loading.close();
        if (res.code != 0) {
            Vue.prototype.$message.error(res.msg);
        }
        return res;
    }).catch(e => {
        loading.close();
        return {code: e.response.status || 500, msg: e.response.data.message};
    });
}

export default {
    get, post, axios: axiosInstance
};